import React from "react";
import Select from "react-select";
import { Label } from "office-ui-fabric-react/lib/Label";

const options = [
  { label: "Combi", value: "Combi" },
  { label: "Trailer 43", value: "Trailer 43" },
  { label: "Trailer 38", value: "Trailer 38" }
];

const TruckTypeSelect = props => {
  const { name, value, label, placeholder, touched, error } = props;

  return (
    <div>
      <Label>{label}</Label>
      <Select
        options={options}
        onChange={value => props.onChange(name, value)}
        onBlur={() => props.onBlur(name, true)}
        value={value}
        placeholder={placeholder}
        simpleValue
      />
      {!!error && touched && <div className="error-message">{error}</div>}
    </div>
  );
};

export default TruckTypeSelect;


// import * as React from 'react';
// import { ComboBox } from 'office-ui-fabric-react/lib/ComboBox';

// const options = [
//   { key: "Combi", text: "Combi", value: 'Combi' },
//   { key: "Trailer 43", text: "Trailer 43", value: 'Trailer 43' },
//   { key: "Trailer 38", text: "Trailer 38", value: 'Trailer 38' }
// ];

// export default class TruckTypeSelect extends React.Component {


//   render() {
//     return (
//       <div >
//         <ComboBox          
//           // defaultSelectedKey="Combi"
//           label="ComboBox"
//           allowFreeform={true}
//           autoComplete="on"
//           options={options}
//           // styles={{
//           //   container: {
//           //     maxWidth: '300px'
//           //   }
//           // }}
//         />
//       </div>
//     );
//   }
// }



// WEBPACK FOOTER //
// ./src/common/Dropdowns/_TruckTypeSelect.js